import Rollbar from 'rollbar'
import get from 'lodash-es/get'

import { config } from '../../config'
import {
  isDevelopment,
  hasWindow,
  isProduction,
  isStaging,
  isTest
} from '../envHelper'
import ignoredMessages from './ignoredMessages'
import checkIgnore from './checkIgnore'
import { allDomains } from '../../constants/siteList'
import hostBlackList from './hostBlackList'

const rollbarClientSideToken = get(
  config,
  'analytics.rollbar.CLIENT_SIDE_TOKEN'
)

if (!rollbarClientSideToken && !isTest()) {
  // eslint-disable-next-line
  console.warn('No rollbar token configured.')
}

let payload = {
  environment: `shopfront-${process.env.NODE_ENV}`
}

// Setup for rollbar sourcemap
// this `GIT_COMMIT_SHA` is generated from `webpack.client.config.js`
// and defined from DefinePlugin
// eslint-disable-next-line
if (GIT_COMMIT_SHA) {
  payload.client = {
    javascript: {
      source_map_enabled: true,
      code_version: GIT_COMMIT_SHA, // eslint-disable-line
      guess_uncaught_frames: true
    }
  }
}

let rollbar = new Rollbar({
  accessToken: rollbarClientSideToken,
  verbose: isDevelopment(),
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload,
  ignoredMessages,
  checkIgnore,
  hostWhiteList: allDomains,
  hostBlackList,
  enabled: isProduction() || isStaging()
})

if (hasWindow()) {
  rollbar.global({
    itemsPerMinute: 30,
    maxItems: 10
  })
}

export default rollbar
